var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSearchIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.9149 16.5436C18.5243 16.1531 17.8912 16.1531 17.5006 16.5436C17.1101 16.9341 17.1101 17.5673 17.5006 17.9578L18.9149 16.5436ZM21.3339 21.7911C21.7244 22.1817 22.3576 22.1817 22.7481 21.7911C23.1386 21.4006 23.1386 20.7674 22.7481 20.3769L21.3339 21.7911ZM17.5006 17.9578L21.3339 21.7911L22.7481 20.3769L18.9149 16.5436L17.5006 17.9578ZM10.541 17.209C6.32984 17.209 2.91602 13.7952 2.91602 9.58398H0.916016C0.916016 14.8997 5.22528 19.209 10.541 19.209V17.209ZM18.166 9.58398C18.166 13.7952 14.7522 17.209 10.541 17.209V19.209C15.8568 19.209 20.166 14.8997 20.166 9.58398H18.166ZM10.541 1.95898C14.7522 1.95898 18.166 5.37281 18.166 9.58398H20.166C20.166 4.26824 15.8568 -0.0410156 10.541 -0.0410156V1.95898ZM10.541 -0.0410156C5.22528 -0.0410156 0.916016 4.26824 0.916016 9.58398H2.91602C2.91602 5.37281 6.32984 1.95898 10.541 1.95898V-0.0410156Z",
    fill: "#F6F6F6"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/searchIcon.ce774cb9f3be467e0baf815078eb1b50.svg";
export { ForwardRef as ReactComponent };